import React from 'react';
import { useLocation } from 'react-router-dom';

import { ErrorBoundary } from '@common/react/components/UI/ErrorBoundary/ErrorBoundary';

import '@app/scss/components/error.scss';

class SentryErrorBoundaryInner extends ErrorBoundary {
	componentDidCatch(error, errorInfo) {
		super.componentDidCatch(error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="error-component">
					<div className="error-component__content">
						<i className="fa fa-exclamation-triangle" aria-hidden="true" />
						<h2>Oops, something went wrong.</h2>
						<h3>Try to refresh this page or feel free to contact us if the problem persists.</h3>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}

export const SentryErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const location = useLocation();

	return <SentryErrorBoundaryInner location={location}>{children}</SentryErrorBoundaryInner>;
};
